import React from "react";
import {cx} from "../lib/ClassSet";
import "./PanelHeaderItem.css";

const PanelHeaderItem = (props) => {

  if (props.show === false) return null;

  let classes = cx({
    "item": true,
    "u-selected": props.selectedId === props.id,
  })

  return (
    <div className={classes} onClick={() => props.onClick(props.id)}>
      <span className="label">{props.label}</span>
    </div>
  )

}

export default PanelHeaderItem;